export const exportUtils = {
  exportToCSV(data, filename = 'export.csv') {
    if (!data || data?.length === 0) {
      alert('No data to export');
      return;
    }

    // Get headers from first object
    const headers = Object.keys(data?.[0]);
    
    // Create CSV content
    const csvContent = [
      headers?.join(','), // Header row
      ...data?.map(row => 
        headers?.map(header => {
          const value = row?.[header];
          // Escape commas and quotes in values
          if (typeof value === 'string' && (value?.includes(',') || value?.includes('"'))) {
            return `"${value?.replace(/"/g, '""')}"`;
          }
          return value;
        })?.join(',')
      )
    ]?.join('\n');

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link?.setAttribute('href', url);
    link?.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
  },

  exportToJSON(data, filename = 'export.json') {
    if (!data) {
      alert('No data to export');
      return;
    }

    const jsonContent = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonContent], { type: 'application/json' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link?.setAttribute('href', url);
    link?.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
  },

  generateReportData(visitors, metrics, trends) {
    const reportDate = new Date()?.toLocaleString();
    
    return {
      reportMetadata: {
        generatedAt: reportDate,
        reportType: 'Visitor Analytics Report',
        totalRecords: visitors?.length || 0
      },
      engagementMetrics: metrics,
      downloadTrends: trends,
      visitorDetails: visitors
    };
  }
};